import React from 'react';
import { Box, TextField, Typography } from '@mui/material';
import { authStyles } from './AuthShell';

// Labeled text field shared across the auth screens: an uppercase caption
// linked to a small full-width TextField. Extra props pass through to TextField.
export default function LabeledField({ id, label, ...textFieldProps }) {
    return (
        <Box>
            <Typography sx={authStyles.label} component="label" htmlFor={id}>
                {label}
            </Typography>
            <TextField id={id} fullWidth size="small" {...textFieldProps} />
        </Box>
    );
}
